import { useState } from "react";

const TEAL    = "#2ABFBF";
const TEAL2   = "#1e9999";
const DARK    = "#111827";
const SILVER  = "#9ca3af";
const FONT    = "'DM Sans','Segoe UI',sans-serif";
const API_BASE = process.env.REACT_APP_API_URL || "";

export default function LoginPage({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError]       = useState("");
  const [loading, setLoading]   = useState(false);

  const handleSubmit = async () => {
    if (!username || !password) { setError("Please enter your username and password."); return; }
    setLoading(true); setError("");
    try {
      const res = await fetch(`${API_BASE}/api/auth`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error || "Invalid username or password."); return; }
      onLogin(data);
    } catch {
      setError("Could not connect to server. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(160deg, #0f1923 0%, #1a2a2a 50%, #0f2020 100%)",
      display: "flex", alignItems: "center", justifyContent: "center",
      fontFamily: FONT, padding: 20,
    }}>
      <div style={{
        position: "fixed", top: "30%", left: "50%", transform: "translateX(-50%)",
        width: 600, height: 600, borderRadius: "50%",
        background: "radial-gradient(circle, rgba(42,191,191,0.12) 0%, transparent 70%)",
        pointerEvents: "none",
      }} />
      <div style={{
        background: "#ffffff", borderRadius: 20,
        boxShadow: "0 24px 80px rgba(0,0,0,0.5), 0 0 0 1px rgba(42,191,191,0.2)",
        width: "100%", maxWidth: 420, overflow: "hidden", position: "relative",
      }}>
        <div style={{ height: 5, background: "linear-gradient(90deg, #1e9999, #2ABFBF, #7ee8e8)" }} />
        <div style={{ padding: "40px 44px 36px" }}>
          <div style={{ textAlign: "center", marginBottom: 32 }}>
            <img src="/PetKennect3D.jpg" alt="PetKennect"
              style={{ height: 90, objectFit: "contain" }}
              onError={e => { e.target.style.display="none"; e.target.nextSibling.style.display="block"; }} />
            <div style={{ display:"none", fontSize:24, fontWeight:800, color:TEAL }}>PetKennect</div>
            <div style={{ fontSize:13, color:SILVER, marginTop:10, fontWeight:500 }}>Client Dashboard Portal</div>
          </div>
          <div style={{ display:"flex", flexDirection:"column", gap:16 }}>
            <div>
              <label style={{ fontSize:11, fontWeight:700, color:"#6b7280", display:"block", marginBottom:6, letterSpacing:"0.08em" }}>USERNAME</label>
              <input type="text" value={username} onChange={e=>setUsername(e.target.value)}
                onKeyDown={e=>e.key==="Enter"&&handleSubmit()} placeholder="Enter your username"
                autoComplete="username"
                style={{ width:"100%", padding:"11px 14px", borderRadius:8, border:"1.5px solid #e5e7eb", fontSize:14, fontFamily:FONT, color:DARK, outline:"none", boxSizing:"border-box", transition:"border-color 0.15s" }}
                onFocus={e=>e.target.style.borderColor=TEAL} onBlur={e=>e.target.style.borderColor="#e5e7eb"} />
            </div>
            <div>
              <label style={{ fontSize:11, fontWeight:700, color:"#6b7280", display:"block", marginBottom:6, letterSpacing:"0.08em" }}>PASSWORD</label>
              <input type="password" value={password} onChange={e=>setPassword(e.target.value)}
                onKeyDown={e=>e.key==="Enter"&&handleSubmit()} placeholder="Enter your password"
                autoComplete="current-password"
                style={{ width:"100%", padding:"11px 14px", borderRadius:8, border:"1.5px solid #e5e7eb", fontSize:14, fontFamily:FONT, color:DARK, outline:"none", boxSizing:"border-box", transition:"border-color 0.15s" }}
                onFocus={e=>e.target.style.borderColor=TEAL} onBlur={e=>e.target.style.borderColor="#e5e7eb"} />
            </div>
            {error && (
              <div style={{ background:"#fef2f2", border:"1px solid #fecaca", borderRadius:8, padding:"10px 14px", fontSize:13, color:"#dc2626" }}>
                {error}
              </div>
            )}
            <button onClick={handleSubmit} disabled={loading}
              style={{ background:loading?SILVER:"linear-gradient(135deg, #1e9999, #2ABFBF)", color:"#fff", border:"none", borderRadius:8, padding:"13px", fontSize:14, fontWeight:700, cursor:loading?"wait":"pointer", fontFamily:FONT, marginTop:4, boxShadow:loading?"none":"0 4px 16px rgba(42,191,191,0.4)", letterSpacing:"0.02em" }}>
              {loading ? "Signing in…" : "Sign In →"}
            </button>
          </div>
          <div style={{ textAlign:"center", marginTop:28, fontSize:12, color:"#9ca3af" }}>
            Need access? Contact{" "}
            <a href="mailto:devika@petkennect.com" style={{ color:TEAL, textDecoration:"none", fontWeight:600 }}>devika@petkennect.com</a>
          </div>
        </div>
      </div>
    </div>
  );
}
